const {Howl, Howler} = require('howler');
const { v4: uuidv4 } = require('uuid');

export var Player = function(){

    this.sound = null;
    this.audio_url = null;
    this.onPlayCallback = null;
    this.onPauseCallback = null;
    this.onStepCallback = null;
    this.onEndCallback = null;
    this.session_id = uuidv4();

}

Player.prototype = {

    getAudioURL:  function(){

        return this.audio_url;

    },

    setAudioURL: function(audio_url){

        this.audio_url = audio_url;

    },

    getSessionId: function(){

        return this.session_id;

    },

    play: function(){

        var self  = this;

        if(null == self.audio_url){

           return;

        }

        if(null ==  self.sound){

            self.initAudio();

        }

        self.sound.play();

    },

    initAudio: function(){

        var self = this;
       
        self.sound = new Howl({
            src: [self.audio_url],
            html5: true,
            onplay: function() {
                
                requestAnimationFrame(self.step.bind(self));

                if(self.onPlayCallback){

                    self.onPlayCallback(self.sound.duration());

                }

            },
            onpause: function() {
            
                if(self.onPlayCallback){

                    self.onPauseCallback(self.sound.duration());

                }

            },
            onseek: function() {
                requestAnimationFrame(self.step.bind(self));
            },
            onend: function() {
               
                if(self.onEndCallback){

                    self.onEndCallback();

                }

            }
        });


    },

    getDuration: function(){

        return this.sound.duration();

    },

    switchAudio: function(){

        var self = this;

        var seek = 0;

        var isPlaying = self.sound.playing();

        if(isPlaying){
            self.sound.pause();
        }

        seek = self.sound.seek();

        self.sound = new Howl({
            src: [self.audio_url],
            html5: true,
            onplay: function() {
                
                requestAnimationFrame(self.step.bind(self));

                if(self.onPlayCallback){

                    self.onPlayCallback(self.sound.duration());

                }

            },
            onpause: function() {
            
                if(self.onPlayCallback){

                    self.onPauseCallback(self.sound.duration());

                }

            },
            onseek: function() {
                requestAnimationFrame(self.step.bind(self));
            },
            onend: function() {
               
                if(self.onEndCallback){

                    self.onEndCallback();

                }

            }
        });

        self.sound.seek(seek);

        if(isPlaying){
            self.sound.play();
        }

    },

    pause: function(){

        this.sound.pause();

    },

    getProgress: function(){

        return Math.round(this.sound.seek());

    },

    seek: function(per) {

        if(null == this.sound){

            return;

        }
        
        this.sound.seek(per);
        
      },

    step: function() {

        var self = this;

        var seek = this.sound.seek() || 0;

        var time = self.formatTime(Math.round(seek));

        var progress = (((seek / this.sound.duration()) * 100) || 0) + '%';

       if(this.onStepCallback){

            this.onStepCallback(time, progress, seek);

       }
  
        // If the sound is still playing, continue stepping.
        if (this.sound.playing()) {
          requestAnimationFrame(self.step.bind(self));
        }

      },

    onStep: function(callback){

        this.onStepCallback = callback;

    },

    onEnd: function(callback){

        this.onEndCallback = callback;

    },

    onPlay: function(callback){

        this.onPlayCallback = callback;

    },

    onPause: function(callback){

        this.onPauseCallback = callback;

    },

    rate: function(rate){

        if(null == this.sound){
            return;
        }

        this.sound.rate(rate);

    },

    formatTime: function(secs) {

        var duration = Math.round(this.sound.duration());
        var timeLeft = duration - secs;

        var minutes = Math.floor(timeLeft / 60) || 0;

        var seconds = (timeLeft - minutes * 60) || 0;
    
        return '- ' + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    }  

}